import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Kiểm tra phần tử 'root' có tồn tại trong DOM không
const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // Nếu sử dụng reportWebVitals, có thể giữ lại dòng này
  reportWebVitals();
} else {
  console.error("Không tìm thấy phần tử #root trong HTML.");
}
